export enum MetricsScene {
  /**
   * 视图-度量模式
   */
  VIEW_MEASURE_MODE = 'view_measure_mode',
  /**
   * 度量视图
   */
  METRICS_VIEW = 'metrics_view',
  /**
   * 图表详情页
   */
  CHART_DETAIL = 'chart_detail',
  /**
   * 图表配置页
   */
  CHART_CONFIG = 'chart_config',
  /**
   * 度量工作项主页
   */
  METRICS_WORKITEM_HOME = 'metrics_workitem_home',
}

export type ContextParams = { project: string; viewId: string };
